<template>
    <div
        class="reo-nav nav-item"
        @mouseenter="sendSimpleEvent('cloud-My Cloud')"
    >
        <a class="reo-nav-text">
            <span>{{ $t('header.management') }}</span>
            <span class="ui-icon icon-icon_down-2"></span>
        </a>
        <div class="nav-dropdown">
            <i class="border-gradient ui-gradient-blue"></i>
            <ul>
                <li
                    v-for="(nav, index) in navList"
                    :key="index">
                    <div @click="sendSimpleEvent(nav.gaLabel)">
                        <router-link
                            :to="{path: nav.path}"
                        >
                            {{ nav.label }}
                        </router-link>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { getNavList } from '../lib/utils';
import reolinkGa from '@/common/js/gtagPageview';

export default Vue.extend({

    data () {

        return {

            navList:getNavList( this.$i18n )

        };

    },
    computed: {

        current () {

            let path = this.$route.path;
            //dashboard内部跳转的一系列页面都要在nav显示dashboard
            if ( path.includes( 'my-sim' )) {

                path = '/user/dashboard';

            }
            let navList = this.navList;
            for ( let nav in navList ) {

                if ( navList[ nav ].path.includes( path )) {

                    return navList[ nav ].label;

                }

            }
            return this.$t( 'nav.cloud' );

        },

        currentLang () {

            return this.$store.state.lang.lang;

        }

    },

    methods: {

        sendSimpleEvent( type ) {

            reolinkGa.sendSimpleEvent( type );

        }

    }
});
</script>

<style scoped lang="less">
    .reo-nav{
        display: inline-block;
        line-height: 0.85rem;
        cursor: pointer;
    }
    .reo-nav:hover .nav-dropdown{
        display: block;
    }
    .reo-nav-text{
        color: @font_primary;
        font-weight: 500;
        font-size: 16px;
        height: 100%;
        display: flex;
        align-items: center;
        &:hover{
            color: @theme;
        }
    }
    .reo-nav .icon-icon_down-2{
        font-size: 16px;
        margin-left: 4px;
        position: relative;
        top: -.02rem;
    }
    .reo-nav .nav-dropdown{
        display: none;
        background-color: #fff;
        margin: 0;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.1);
        top: 83px;
    }
    .reo-nav .nav-dropdown li{
        line-height: .6rem;
        position: relative;
        white-space: nowrap;
    }
    .reo-nav .nav-dropdown li a{
        padding: 0 .25rem;
        color: #555;
        font-size: .16rem;
        font-weight: 500;
        text-decoration: none;
        display: block;
        text-align: center;
        line-height: .6rem;
        border-bottom: 0;
        margin: 0;
    }
    .reo-nav .nav-dropdown li a:hover{
        background-color: #f7f8f9;
        color: @theme;
    }

    .reo-nav .pc-body .nav-item:hover .nav-dropdown{
        display: block;
    }
</style>
